import { Container } from '@/atoms';
import { CardBanner, Grid } from '@/molecules';
import { ProductBlock } from '@/organisms';

import { CardProductAlgolia } from '@/components/algolia';
import { cardBannerTransformer } from '@/lib/graphql/transformers';
import { removeBaseURL } from '@/lib/utils';

import type {
  TypeCardBannerGraphQL,
  TypeProductAlgolia,
} from '@/lib/graphql/types';

const ProductsByBrand = ({ bloque, id }: any) => {
  const {
    titulo,
    backgroundColor,
    description,
    link,
    products,
    path,
  }: {
    titulo: string;
    backgroundColor: string;
    description: string;
    link: {
      label: string;
      link: { url: string };
      size: 'body' | 'small' | 'large';
      style: 'primary' | 'secondary' | 'alternative' | 'current-color';
    };
    products: (
      | TypeProductAlgolia
      | { id: string; cpt_banner: TypeCardBannerGraphQL; __typename: string }
    )[];
    path: string;
  } = bloque;

  return (
    <Container
      id={id}
      wrapper
      as="section"
      {...(backgroundColor
        ? {
            style: { backgroundColor },
            padding: 'px-4 py-8 md:py-16',
          }
        : {})}
    >
      <ProductBlock
        {...(titulo ? { title: titulo } : {})}
        {...(link && link.link?.url && link?.label
          ? {
              link: {
                href: removeBaseURL(link.link.url),
                label: link.label,
                size: link.size,
                style: link.style,
              },
            }
          : {})}
        {...(description ? { description: description } : {})}
        productos={products}
        itemListId={path}
        itemListName={path}
      >
        <Grid>
          {products.map((p, i) => {
            if ('__typename' in p && p.__typename === 'Banner') {
              return (
                <Grid.Item key={i} colSpanXXS={p?.cpt_banner?.double ? 2 : 1}>
                  <CardBanner {...cardBannerTransformer(p.cpt_banner)} />
                </Grid.Item>
              );
            }

            if ('sku' in p) {
              return (
                <Grid.Item key={p.id}>
                  <CardProductAlgolia
                    hit={p}
                    itemListId={path}
                    itemListName={path}
                    itemIndex={i}
                  />
                </Grid.Item>
              );
            }
          })}
        </Grid>
      </ProductBlock>
    </Container>
  );
};

export default ProductsByBrand;

ProductsByBrand.displayName = 'ProductsByBrand';
